<template>
  <v-card>
    <v-toolbar dark color="blue">
      <v-btn icon dark @click.native="close" :disabled="loading">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>เพิ่มเจ้าหน้าที่</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field required
                label="Username"
                v-model="item.username"
                :rules="[rules.required]"
                append-icon="search"
                @click:append="lookupUsername(item.username)"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-radio-group v-model="item.enabled" row>
                <v-radio label="เปิดสิทธิการใช้งาน" :value="true" color="green"></v-radio>
                <v-radio label="ปิดสิทธิการใช้งาน" :value="false" color="red"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field required
                label="ชื่อ"
                v-model="item.firstname"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field required
                label="นามสกุล"
                v-model="item.lastname"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field required
                label="ชื่อเต็ม"
                v-model="item.fullname"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field required
                label="อีเมล"
                v-model="item.email"
                :rules="[rules.required, rules.email]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="gangList"
                v-model="item.gangs"
                return-object
                :item-text="gangText"
                item-value="id"
                label="บทบาท"
                multiple
                chips
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pl-3 pr-3">
      <v-btn color="grey darken-2 white--text" :loading="loading" @click.native="close">ปิด</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="green white--text" :loading="loading" @click.native="save(item)" :disabled="!valid">บันทึก</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import swal from 'sweetalert2'

export default {
  name: 'AddOfficerDialog',
  props: [ 'dialog' ],
  data () {
    return {
      loading: false,
      valid: false,
      item: {
        id: null,
        username: null,
        enabled: null,
        gangs: []
      },
      gangList: [],
      rules: {
        required: value => !!value || 'กรุณากรอกข้อมูล.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'รูปแบบอีเมลไม่ถูกต้อง.'
        }
      }
    }
  },
  methods: {
    gangText: item => item.authority + ' : ' + item.description,
    lookupUsername (username) {
      if (username && username.length > 2) {
        this.loading = true
        this.$store.dispatch('officer/lookup', username)
          .then((response) => {
            this.item = Object.assign(response.data, this.item)
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.$snotify.error(`${error.response.data.error}:${error.response.data.message}`, 'ไม่สำเร็จ!')
          })
      }
    },
    reset () {
      this.item = {
        id: null,
        username: null,
        enabled: null,
        gangs: []
      }
    },
    close () {
      this.reset()
      this.$events.fire('closeDialog', 'addedDialog')
    },
    save (item) {
      this.loading = true
      this.$store.dispatch('officer/create', item)
        .then(response => {
          this.loading = false
          swal({
            title: 'บันทึกเรียบร้อย!',
            type: 'success'
          }).then(response => {
            this.close()
          })
        }).catch(error => {
          this.loading = false
          swal('เกิดข้อผิดพลาด!', (error.response.data) ? error.response.data.message : error.message, 'error')
        })
    }
  },
  created () {
    this.$store.dispatch('gang/list')
      .then(response => {
        this.gangList = response.data
      })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/officer/addOfficerDialog.vue